import { IconSizeTokens } from '@voltmoney/schema';
export const IconSizeTokensMap = {
    [IconSizeTokens.XXS]: 10,
    [IconSizeTokens.XS]: 12,
    [IconSizeTokens.SM]: 14,
    [IconSizeTokens.MD]: 16,
    [IconSizeTokens.LG]: 18,
    [IconSizeTokens.XL]: 20,
    [IconSizeTokens.XXL]: 24,
    [IconSizeTokens.XXXL]: 28,
    [IconSizeTokens.XXXXL]: 32,
    [IconSizeTokens.XXXXXL]: 40,
    [IconSizeTokens.XXXXXXL]: 48,
    [IconSizeTokens.Size52]: 52,
    [IconSizeTokens.Size56]: 56,
    [IconSizeTokens.Size96]: 96,
    [IconSizeTokens.XXXXXXXL]: 60,
    [IconSizeTokens.XXXXXXXXL]: 85,
    [IconSizeTokens.Size36]: 36,
    [IconSizeTokens.LARGE_DLS]: 48,
    [IconSizeTokens.MEDIUM_DLS]: 40,
    [IconSizeTokens.SIZE_164]: 164,
    [IconSizeTokens.SMALL_DLS]: 24,
    [IconSizeTokens.SIZE_WEB_FULL]: 508,
};
